module.exports = __webpack_public_path__ + "img/northern_cyprus.9d6aacf9.svg";